import "./chunk-A4LKEGQ6.js";
import {
  getCurrentInstance,
  inject,
  onBeforeUnmount,
  ref
} from "./chunk-6WDJ6AHL.js";
import "./chunk-LFBQMW2U.js";

// node_modules/.pnpm/@dreamonkey+vue-signalr@1.0.1_@microsoft+signalr@7.0.0_vue@3.2.45/node_modules/@dreamonkey/vue-signalr/dist/symbols.js
var SignalRSymbol = Symbol("SignalRService");

// node_modules/.pnpm/@dreamonkey+vue-signalr@1.0.1_@microsoft+signalr@7.0.0_vue@3.2.45/node_modules/@dreamonkey/vue-signalr/dist/composable.js
function useSignalR() {
  const signalr = inject(SignalRSymbol);
  if (!signalr) {
    throw new Error("Failed to inject SignalR");
  }
  return signalr;
}

// node_modules/.pnpm/@dreamonkey+vue-signalr@1.0.1_@microsoft+signalr@7.0.0_vue@3.2.45/node_modules/@dreamonkey/vue-signalr/dist/mapping.js
var methodNamesMap = /* @__PURE__ */ new Map();
function remapMethod(name, alias) {
  methodNamesMap.set(alias, name);
}
function remapMethods(mappings) {
  for (const [name, alias] of mappings) {
    remapMethod(name, alias);
  }
}
function resolveMethodName(nameOrAlias) {
  return methodNamesMap.get(nameOrAlias) || nameOrAlias;
}

// node_modules/.pnpm/@dreamonkey+vue-signalr@1.0.1_@microsoft+signalr@7.0.0_vue@3.2.45/node_modules/@dreamonkey/vue-signalr/dist/service.js
function createService({
  connection,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  failFn = () => {
  },
  autoOffInsideComponentScope = true
}) {
  const connected = ref(false);
  const invokeQueue = [];
  const activeListenersSet = /* @__PURE__ */ new Set();
  connection.onclose(failFn);
  async function init() {
    try {
      await connection.start();
      connected.value = true;
      while (invokeQueue.length) {
        const action = invokeQueue.shift();
        action && action();
      }
    } catch (error) {
      failFn(error);
    }
  }
  function invoke(methodName, ...payload) {
    return new Promise((resolve, reject) => {
      const invokeFn = () => connection.invoke(resolveMethodName(methodName), ...payload).then(resolve).catch(reject);
      if (connected.value) {
        invokeFn();
      } else {
        invokeQueue.push(invokeFn);
      }
    });
  }
  function on(methodName, callback, { skip, once: once2 } = {}) {
    const originalMethodName = resolveMethodName(methodName);
    connection.on(originalMethodName, (...payload) => {
      const _payload = payload;
      if (skip && skip(..._payload)) {
        return;
      }
      if (once2) {
        off(methodName, callback);
      }
      callback(..._payload);
    });
    if (autoOffInsideComponentScope) {
      const instance = getCurrentInstance();
      if (instance) {
        activeListenersSet.add(callback);
        onBeforeUnmount(() => {
          if (activeListenersSet.delete(callback)) {
            off(methodName, callback);
          }
        });
      }
    }
  }
  function once(methodName, callback, options = {}) {
    on(methodName, callback, { ...options, once: true });
  }
  function off(methodName, callback) {
    const originalMethodName = resolveMethodName(methodName);
    if (callback) {
      connection.off(originalMethodName, (...payload) => {
        const _payload = payload;
        callback(..._payload);
      });
    } else {
      connection.off(originalMethodName);
    }
  }
  return {
    init,
    connected,
    invoke,
    on,
    off,
    once
  };
}

// node_modules/.pnpm/@dreamonkey+vue-signalr@1.0.1_@microsoft+signalr@7.0.0_vue@3.2.45/node_modules/@dreamonkey/vue-signalr/dist/plugin.js
var VueSignalR = {
  install(app, options) {
    const service = createService(options);
    app.provide(SignalRSymbol, service);
    service.init();
  }
};
export {
  SignalRSymbol,
  VueSignalR,
  createService,
  remapMethod,
  remapMethods,
  resolveMethodName,
  useSignalR
};
//# sourceMappingURL=@dreamonkey_vue-signalr.js.map
